import computeInterviewPayload from '@Application/Beneficiaries/Interviews/Actions/computeInterviewPayload';
import type {
	ComputedInterviewPayload,
	InterviewPayload,
} from '@Application/Beneficiaries/Interviews/Actions/interviewsFetched';

export type InterviewFetchedAction = {
	type: 'INTERVIEW_FETCHED';
	payload: ComputedInterviewPayload;
	facilityId: number;
	subjectId: number;
};

export default (
	payload: InterviewPayload,
	facilityId: number,
	subjectId: number,
): InterviewFetchedAction => ({
	type: 'INTERVIEW_FETCHED',
	payload: computeInterviewPayload(payload),
	facilityId,
	subjectId,
});
